module.exports = __webpack_public_path__ + "assets/certificate_pdf/MTA Cloud Fundamentals_98-369_F224-83028298419.d8b4e5f0.pdf";